"use client"

import { StarOff } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `StarOffIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const StarOffIcon = component(Icon)({ as: StarOff })
